export default "__VITE_ASSET__C662N4Ht__"